<app-pageheader [Parent]="this">
  @if (CanWrite) {
    <add-button AddRoute="/enforcement/citation-exemption-lists/new"></add-button>
  }
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false"
  ApiUrl="enforcement/citation-exemption-lists/searches"
  [AllowEdit]="true" EditUrl="enforcement/citation-exemption-lists/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>
